import DOMPurify from 'dompurify';
import { MediaTypeTranslation, getMediaType } from '../../../../media-type-translation/index.js';
import { version } from '../../../../version';

const [ MAJOR_VERSION ] = version.split('.');

export class DocumentListItemMetadata extends HTMLElement {
    #country;
    #date;
    #mediaType;
    #source;

    static get tagName () {
        return `ua-applet-document-list-item-metadata-v${MAJOR_VERSION}`;
    }

    constructor () {
        super();
        this.attachShadow({ mode: 'open' });
    }

    set document (value) {
        this.#country = value.country !== 'zz' ? value.country : '';
        this.#date = value.date;
        this.#mediaType = getMediaType(value);
        this.#source = value.source;

        this.#render();
    }

    #render () {
        this.shadowRoot.innerHTML = /*html*/`
            <style>
                .metadata {
                    font-size: 10px;
                    font-weight: 400;
                    line-height: 16px;
                    visibility: 'hidden';
                }

                .media-type {
                    color: var(--flux-color-aqua);
                    font-weight: 700;
                }

                .country {
                    text-transform: uppercase;
                }

                flux-date-time {
                    display: inline;
                }
            </style>

            <div class="metadata">
                <span class="media-type"><${MediaTypeTranslation.tagName} type="${this.#mediaType}"></${MediaTypeTranslation.tagName}> |</span>
                <span class="source">${DOMPurify.sanitize(this.#source)} |</span>
                <span class="country">${DOMPurify.sanitize(this.#country)} |</span>
                <flux-date-time date="${this.#date}"></flux-date-time>
            </div>
        `;

        if (!this.#country || this.#country === 'zz') {
            this.shadowRoot.querySelector('.country').style.display = 'none';
        }

        if (!this.#date) {
            this.shadowRoot.querySelector('flux-date-time').style.display = 'none';
        }

        if (!this.#mediaType) {
            this.shadowRoot.querySelector('.media-type').style.display = 'none';
        }

        if (!this.#source) {
            this.shadowRoot.querySelector('.source').style.display = 'none';
        }
    }
}

if (!customElements.get(DocumentListItemMetadata.tagName)) {
    customElements.define(DocumentListItemMetadata.tagName, DocumentListItemMetadata);
}
